'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = resolveMultiPredicates;

var _prismicJavascript = require('prismic-javascript');

var _prismicJavascript2 = _interopRequireDefault(_prismicJavascript);

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}

function resolveMultiPredicates(multiPredicates) {
  return multiPredicates.map(function (item) {
    var predicate = item.predicate,
        path = item.path,
        value = item.value;
    return _prismicJavascript2.default.Predicates[predicate](path, value);
  });
}